export default __webpack_public_path__ + "static/desktop_15-2f03011dd0c28cf26f5619e7061059e5.webp";